<div class="app-select-container" [formGroup]="group">
    <label class="app-select-label" *ngIf="label" [for]="id">
        <span *ngIf="getRequired()" class="required-field"
            [class.error]="getInvalid()">*</span>
        {{ label }}
    </label>

    <div class="app-select-entry-container" [ngClass]="getClasses()"
        [class.readonly]="!!readOnly" [class.invalid]="getError()">

        <ng-select #ngSelect [closeOnSelect]="!multiple"
            [formControlName]="controlName" [items]="visibleItems"
            [labelForId]="id" [placeholder]="placeholder" [multiple]="multiple"
            [readonly]="!!readOnly"
            [dropdownPosition]="dropdownPosition || 'auto'"
            [inputAttrs]="{autocomplete:'nope', name: controlName, id: id}"
            (open)="onOpen()" (close)="onClose()">
            <ng-template ng-option-tmp let-item="item" *ngIf="multipleLines">
                <div>{{ item.label }}</div>
                <div class="extra-info">{{ item.extra }}</div>
            </ng-template>
        </ng-select>

        <div *ngIf="getError()" class="app-select-icon error">
            <svg-icon src="assets/images/icon-error.svg"></svg-icon>
        </div>
    </div>
    <p class="app-select-helper" *ngIf="helpText && !getError()">{{helpText}}
    </p>
    <p class="app-select-error" *ngIf="getError()">{{getErrorMessage()}}</p>
</div>